<template>
    <div
        v-if="Object.keys(data).length > 0 && data !== null && data !== undefined"
        class="simple-counter-block"
        :style="{ '--counter-color': data.counterColor }"
    >
        <div>
            <div class="simple-counter-block__inner">
                <span v-if="iconClass">
                    <i :class="iconClass"></i>
                </span>
                <span class="simple-counter-block__inner-text">
                    {{ data.title }}
                </span>
            </div>
            <div>
                <span class="simple-counter-block__value" :style="{ color: data.counterColor }">
                    {{ data.value }}
                </span>
            </div>
            <el-divider :class="'custom-divider'"/>
            <div>
                <span class="simple-counter-block__detail-value" :style="{ color: data.detailColor || data.counterColor }">
                    {{ data.detailValue }}
                </span>
                <span class="simple-counter-block__detail-text" :style="{ color: data.detailColor || data.counterColor }">
                    {{ data.detailText }}
                </span>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        iconClass: {
            type: String,
            default: () => ''
        }
    }
};

</script>

<style lang="scss" scoped>
.simple-counter-block {
    background: var(--white);
    border-radius: 3px;
    padding: 16px;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);

    .simple-counter-block__inner {
        margin-right: 3px;
        display: flex;
        justify-content: left;
        align-items: center;

        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
        .lyra-icon {
            display: flex;
            padding-right: 0.5rem;
        }
        .lyra-icon::before {
            content: '';
            width: 20px !important;
            height: 20px !important;
            background-color: var(--counter-color) !important;
            opacity: 1;
        }
    }
    span {
        padding: 3px;
        &.simple-counter-block__inner-text {
            max-width: 250px;
            font-weight: 500;
            color: var(--primary) !important;
        }
    }
    .simple-counter-block__value {
        font-size: 24px;
        font-weight: 500;
    }
}
.el-divider--horizontal {
    margin: 8px 0 8px 0 !important;
}
.simple-counter-block__detail-value {
    font-weight: 500 !important;
}
</style>
